import { render, staticRenderFns } from "./ComboboxEixo.vue?vue&type=template&id=6ae8aacf&scoped=true&"
import script from "./ComboboxEixo.vue?vue&type=script&lang=js&"
export * from "./ComboboxEixo.vue?vue&type=script&lang=js&"
import style0 from "./ComboboxEixo.vue?vue&type=style&index=0&id=6ae8aacf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae8aacf",
  null
  
)

export default component.exports